var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"affairs-list"},_vm._l((_vm.grouped_tasks),function(item){return _c('AffairListItem',{key:item.id,attrs:{"data":item},on:{"assignToManager":_vm.onAssignToManager,"editTask":_vm.onEditTask}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }